module.exports = __webpack_public_path__ + "static/media/difc.098f98fa.jpeg";